import { useMemo } from 'react';
import { threadState, useAppSelector } from 'src/store';
import {
  useComparingConversationsParams,
  useConversationParams,
} from 'src/hooks';
import { DEFAULT_CHAT_ID } from 'src/constants';

export const useThreadRegistry = () => {
  const { threadsStatusRegistry } = useAppSelector(threadState);

  const { currentConversationId } = useConversationParams();
  const { firstComparedConvId, secondComparedConvId } =
    useComparingConversationsParams();

  const ignoreMessages = useMemo(
    () =>
      currentConversationId !== DEFAULT_CHAT_ID
        ? threadsStatusRegistry[currentConversationId]?.ignoreMessages
        : false,
    [threadsStatusRegistry, currentConversationId],
  );

  const isSubmitHappened = useMemo(
    () =>
      currentConversationId !== DEFAULT_CHAT_ID
        ? threadsStatusRegistry[currentConversationId]?.isSubmitHappened
        : false,
    [threadsStatusRegistry, currentConversationId],
  );

  const isSubmitCompareModeHappened = useMemo(
    () =>
      firstComparedConvId && secondComparedConvId
        ? threadsStatusRegistry[firstComparedConvId]?.isSubmitHappened ||
          threadsStatusRegistry[secondComparedConvId]?.isSubmitHappened
        : false,
    [firstComparedConvId, secondComparedConvId, threadsStatusRegistry],
  );

  return {
    ignoreMessages,
    isSubmitHappened: isSubmitHappened || isSubmitCompareModeHappened,
  };
};
